import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Text,
    Box,
    ModalFooter,
} from "@chakra-ui/react"
import { useEffect, useRef, useState } from "react"
import Download from "./Download"
import ScoreTile from "./ScoreTile"

export default function Scorecard({ isOpen, onClose, questions, scoreDetails }) {
    const cancelRef = useRef()
    const [answerSheet, setAnswerSheet] = useState([])

    console.log(questions, scoreDetails)

    useEffect(() => {
        let currentAnswerSheet = scoreDetails[1].map(question => {
            return {
                "question": questions.find(q => q.id === Number(question.question_id)).question,
                "correct_answer": question.right_choice,
                "your_answer": question.user_choice
            }
        })
        setAnswerSheet(currentAnswerSheet)
        // eslint-disable-next-line
    }, [questions])
    return (
        <Modal
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            closeOnOverlayClick={false}
            size='xl'
            isCentered
            scrollBehavior='inside'
        >
            <ModalOverlay>
                <ModalContent
                    height='400px'
                    borderRadius='20px'
                    pb='3'
                >
                    <ModalHeader fontSize="lg" fontWeight="bold" d='flex' justifyContent='space-between' alignItems='center' pr='3rem'>
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontSize={['24px', '24px', '26px', '28px']}
                            fontWeight='900'
                            color='#000000'
                        >
                            Scorecard
                        </Text>
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontSize={['14px', '14px', '16px', '18px']}
                            fontWeight='700'
                            color='#4dbd4d'
                        >
                            Your Score {scoreDetails[0]}/100
                        </Text>
                    </ModalHeader>
                    <ModalCloseButton color='#00000066' />

                    <ModalBody
                        sx={{
                            '&::-webkit-scrollbar': {
                                width: '10px',
                                borderRadius: '8px',
                                backgroundColor: `transparent`,
                                height: '90%',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: `rgba(0, 0, 0,0.2)`,
                                borderRadius: '20px'
                            },
                        }}
                    >
                        <Box
                            w='100%'
                            overflowY='auto'
                            d='flex'
                            flexDir='column'
                        >
                            {
                                scoreDetails &&
                                scoreDetails[1]?.map(question => <ScoreTile
                                    key={question.id + (Math.random()*100) }
                                    question={questions.find(q => q.id === Number(question.question_id)).question}
                                    rightAnswer={question.right_choice}
                                    userChoice={question.user_choice}
                                />)}
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Box
                            fontSize='18px'
                            color='#ffffff'
                            fontWeight='800'
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            placeholder='Quiz'
                            border='1px solid rgba(0, 0, 0, 0.1)'
                            bg='#cebc1f'
                            justifyContent='center'
                            alignItems='center'
                            display='flex'
                            borderRadius='10px'
                            height='44px'
                            _hover={{ bg: '#b9a91a' }}
                            cursor='pointer'
                        >
                            <Download answerSheet = {answerSheet} />
                        </Box>
                    </ModalFooter>
                </ModalContent>
            </ModalOverlay>
        </Modal>
    )
}